import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class ButtonsOnDateAndTimePicker implements IFlagFeature {
  name = Features.DATE_AND_TIME_CTRL_BTNS_UI;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
